export type Task = {
  id: string;
  title: string;
  priority: '高' | '中' | '低';
  projectId: string;
  projectName: string;
  dueDate: string;
  dueTime: string;
  completed: boolean;
  createdAt: string;
};

export const tasks: Task[] = [
  {
    id: 't1',
    title: '完成本周选题与内容框架',
    priority: '高',
    projectId: 'p1',
    projectName: '个人品牌内容计划',
    dueDate: '2026-08-03',
    dueTime: '18:00',
    completed: false,
    createdAt: '2026-07-30T10:00:00',
  },
  {
    id: 't2',
    title: '阅读美联储7月会议纪要分析',
    priority: '高',
    projectId: 'p2',
    projectName: '投资学习计划',
    dueDate: '2026-08-03',
    dueTime: '20:00',
    completed: false,
    createdAt: '2026-08-01T09:00:00',
  },
  {
    id: 't3',
    title: '整理东京行程住宿清单',
    priority: '中',
    projectId: 'p3',
    projectName: '旅行规划',
    dueDate: '2026-08-04',
    dueTime: '12:00',
    completed: false,
    createdAt: '2026-08-02T14:00:00',
  },
  {
    id: 't4',
    title: '回复教练训练计划调整',
    priority: '中',
    projectId: '',
    projectName: '',
    dueDate: '2026-08-03',
    dueTime: '10:00',
    completed: true,
    createdAt: '2026-08-02T08:00:00',
  },
  {
    id: 't5',
    title: '更新个人网站关于页面',
    priority: '低',
    projectId: 'p1',
    projectName: '个人品牌内容计划',
    dueDate: '2026-08-05',
    dueTime: '18:00',
    completed: false,
    createdAt: '2026-08-01T16:00:00',
  },
  {
    id: 't6',
    title: '确定9月旅行预算上限',
    priority: '中',
    projectId: 'p3',
    projectName: '旅行规划',
    dueDate: '2026-08-06',
    dueTime: '20:00',
    completed: false,
    createdAt: '2026-08-02T11:00:00',
  },
  {
    id: 't7',
    title: '阅读《价值投资实战手册》第三章',
    priority: '中',
    projectId: 'p2',
    projectName: '投资学习计划',
    dueDate: '2026-08-07',
    dueTime: '22:00',
    completed: false,
    createdAt: '2026-08-03T07:00:00',
  },
  {
    id: 't8',
    title: '整理书房书籍并捐赠旧书',
    priority: '低',
    projectId: '',
    projectName: '',
    dueDate: '2026-08-10',
    dueTime: '18:00',
    completed: false,
    createdAt: '2026-08-02T16:00:00',
  },
  {
    id: 't9',
    title: '完成上周复盘总结',
    priority: '高',
    projectId: 'p1',
    projectName: '个人品牌内容计划',
    dueDate: '2026-08-02',
    dueTime: '23:00',
    completed: true,
    createdAt: '2026-08-01T08:00:00',
  },
  {
    id: 't10',
    title: '预约牙科检查',
    priority: '低',
    projectId: '',
    projectName: '',
    dueDate: '2026-08-08',
    dueTime: '14:00',
    completed: false,
    createdAt: '2026-08-03T08:00:00',
  },
];
